import React, { useState } from 'react';
import { SaveButton, Toolbar, useRedirect } from 'react-admin';
import ConfirmDeleteButton from './ConfirmDeleteButton'
import useUser from '../hooks/useUser';

import CancelButton from './CancelButton'

const EditConfirmToolbar = props => {
    const [saving, setSaving] = useState(false)
    const user = useUser()
    const redirectTo = useRedirect();
    const update = (tbredirect) => {
        console.log({tbredirect})
        if (props.history) props.history.goBack()
        redirectTo(tbredirect)
    }
    const handleSave = async (data) => {
        setSaving(true)
        await props.handlesave(data)
        setSaving(false)
    }

    const deleteRedirect = (tbredirect) => {
        if (tbredirect) redirectTo(tbredirect)
        else if (props.history) props.history.goBack()
    }

    const canDelete = () => {
        if (user.role === 'super-admin') return true
        if (props.dataprovidersource === "contacts") return true 
        
    }

    return (
        <Toolbar {...props} pristine={false}  >
            {!saving ? <SaveButton
                label="save"
                redirect="show"
                submitOnEnter={true}
                onSave={handleSave}
            />: <></>}
            <CancelButton history={props.history} />
            {!props.hideDelete && props.creating !== true && canDelete() && <ConfirmDeleteButton
                filled={true}
                dataprovidersource={props.dataprovidersource}
                alertmessage={props.alertM}
                update={() => deleteRedirect(props.tbredirect)}
                history={props.history}
            />}
        </Toolbar>
    );
}

export default EditConfirmToolbar;